export default __webpack_public_path__ + "static/media/supply-group-icon.4e29ae0e.svg";